import styled from '@emotion/styled';

import { tokens } from '@hotjar/hotsauce';

export const DetailLabel = styled.span`
  border-bottom: 1px dashed transparent;
  color: ${tokens.color.text_light};
  cursor: pointer;
  display: inline-block;
  font-size: 11px;
  font-weight: normal;
  margin-bottom: 12px;
  text-align: left;
  text-transform: uppercase;
`;
